module.exports = __webpack_public_path__ + "static/media/Galdisa_Ficha_garbanzo_enchilado.4f7db580.pdf";